<pp-select
  [ppItems]="frequencies"
  [ppSelectedItem]="frequencies[selectedFrequencyIndex]"
  (ppSelectItem)="selectItem($event)"
  [ppNoSearchBar]="true"
  [ppDisplaySubtext]="true"
  [ppDisabled]="ppDisabled"
  require
  >
  <ng-container selected>
    @if (selectedFrequencyIndex !== -1) {
      <span
        class="frequencyPicker__selected"
        [class.frequencyPicker__selected--disabled]="ppDisabled"
        >
        {{ frequencies[selectedFrequencyIndex].label }}
      </span>
    }

    @if (selectedFrequencyIndex === -1) {
      <span class="frequencyPicker__placeholder">
        {{ 'does_not_repeat' | ppTranslate }}
      </span>
    }
  </ng-container>
</pp-select>
